<template>
  <div class="contbg">
    <a-card>
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item
            label="审核状态:"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-select v-model="searchObj.status" style="width:100%">
              <a-select-option v-for="(item,i) in statusList" :key="i" :value="item.id*1">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item
            label="提交人:"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-input v-model="searchObj.submitUser" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :md="7" :sm="24">
          <a-form-item
            label="用户昵称:"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-input v-model="searchObj.nickName" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :md="4" :sm="24" style="padding:4px 0">
          <a-button @click="reset()">重置</a-button>
          <a-button @click="search()" class="mgl10" type="primary">查询</a-button>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item
            label="消息属性:"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-select v-model="searchObj.attribute" style="width:100%">
              <a-select-option v-for="(item,i) in attributeList" :key="i" :value="item.id*1">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item
            label="部门:"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-input v-model="searchObj.orgName" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :md="7" :sm="24">
          <a-form-item
            label="标题:"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-input v-model="searchObj.title" placeholder="请输入" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="6" :sm="24">
          <a-form-item label="时间:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
            <a-range-picker
              style="width: 380px;"
              :value="searchObj.rangdate"
              @change="dateChange"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{
                hideDisabledOptions: true,
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
              }"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card class="mgt16">
      <a-table rowKey="id" :loading="loading" :columns="columns" :dataSource="dataSource" :pagination="false">
        <template slot="operate" slot-scope="text, record">
          <div class="operate" @click="goDetail(record)">{{ record.manualStatus==0?'审核':'查看' }}</div>
        </template>
        <template slot="headerNick" slot-scope="text,record">
          <img :src="record.profileHeadImg" class="u_header" alt="">
          <span>{{ record.profileNickname }}</span>
        </template>
        <template slot="aiAuditStatus" slot-scope="text,record">
          <div><span :class="'ad_status status_'+record.aiAuditStatus"></span>{{ getStatus(record.aiAuditStatus) }}</div>
          <div>{{ record.aiAuditLabel }}</div>
        </template>
        <template slot="manualStatus" slot-scope="text, record">
          <div>{{ getStatus(record.manualStatus) }}</div>
        </template>
        <!-- <template slot="msgContent" slot-scope="text, record">
          <div v-if="record.msgType==2">
            <video :src="record.msgContent" class="v_video"></video>
          </div>
          <div v-else class="msgcontent" v-html="record.msgContent"></div>
        </template> -->
        <template slot="msgTitle" slot-scope="text, record">
          <div class="msgcontent">{{ record.msgTitle }}</div>
        </template>
      </a-table>
      <div style="margin-top: 10px;text-align: right">
        <a-pagination
          :showSizeChanger="true"
          :showQuickJumper="true"
          @change="changePage"
          @showSizeChange="changeLimitNum"
          :show="pageObj.total > 0"
          :current="pageObj.current"
          :total="pageObj.total"
          :defaultPageSize="pageObj.pageSize"
          :showTotal="total => `总共 ${total} 条数据`"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
import { getMaterialList } from '@/api/markethelp'
import { depList } from '@/api/common'
import moment from 'moment'
  export default {
    name:'Auditcontlist',
    data(){
      return{
        loading:false,
        searchObj:{
          deptype:'1',//业务类型
          depId:'',
          submitUser:'',
          nickName:'',
          status:0,
          attribute:-1,
          orgName: '',
          title: '',
          rangdate: null,
          startTime: '',
          endTime: ''
        },
        columns:[
          {title: '素材ID', dataIndex: 'msgId'},
          {title: '上传员工', dataIndex: 'submitUser'},
          {title: '用户头像/昵称', dataIndex: 'headerNick',scopedSlots:{customRender: 'headerNick'}},
          // {title: '内容', dataIndex: 'msgContent',scopedSlots: {customRender: 'msgContent'},ellipsis: true,width:"300px"},
          {title: '标题', dataIndex: 'msgTitle',scopedSlots: {customRender: 'msgTitle'},ellipsis: true,width:'300px'},
          {title: '发布时间', dataIndex: 'submitTime'},
          {title: '机审结果', dataIndex: 'aiAuditStatus', scopedSlots: {customRender: 'aiAuditStatus'}},
          {title: '人工审核结果', dataIndex: 'manualStatus', scopedSlots: {customRender: 'manualStatus'}},
          {title: '操作', dataIndex: 'operate', scopedSlots: {customRender: 'operate'}}
        ],
        dataSource:[],
        businssDept: [],
        statusList:[
          {id:-1,name:'全部'},
          {id:0,name:'待审核'},
          {id:1,name:'已通过'},
          {id:2,name:'未通过'}
        ],
        attributeList:[
          {id:-1,name:'全部'},
          {id:0,name:'默认'},
          {id:1,name:'取消/过期'},
        ],
        pageObj: {
          current: 1,
          pageSize: 10,
          total: 1,
          changeLimitNum: false
        },
        total:0,
        pagename:'markethelp'
      }
    },
    mounted() {
      this.initSearch()
      this.init()
      this.search()
    },
    methods: {
      dateChange (date, dateString) {
        this.searchObj.startTime = dateString[0]
        this.searchObj.endTime = dateString[1]
        this.searchObj.rangdate = date
      },
      moment,
      initSearch(){
        var pagesearch = this.$store.state.user.pageSearch[this.pagename]||{}
        this.searchObj = Object.assign(this.searchObj,pagesearch)
      },
      init(){
        depList().then(res => {
          if (res.code == 1) {
            if (window.environment == 'bz') {
              this.businssDept = res.result.filter(item => item.name == '博众事业部')
            } else {
              this.businssDept = res.result
            }
          }
        })
      },
      goDetail(item){
        this.$router.push({ name: 'marketDetail', params: {id:item.id } })
      },
      getList(){
        var params = {
          pageSize: this.pageObj.pageSize,
          page: this.pageObj.current,
          ...this.searchObj
        }
        // 删除存储的时间区间
        delete params.rangdate

        if(this.searchObj.status==-1){
          delete params.status
        }
        if(this.searchObj.attribute==-1){
          delete params.attribute
        }
        this.$store.commit('SET_PAGESEARCH', {page:this.pagename,search:this.searchObj})

        if(this.loading){return}
        this.loading = true

        getMaterialList(params).then((res) => {
          this.loading = false
          if(res.code == 1 && res.result){
            this.dataSource = res.result.list
            this.pageObj.current = res.result.page.index
            this.pageObj.total = res.result.page.total
          }else{
            this.$message.error(res.message)
          }
        })
      },
      reset(){
        this.searchObj = {
          deptype:'1',//业务类型
          depId:'',
          submitUser:'',
          nickName:'',
          status:0,
          attribute:-1,
          orgName: '',
          rangdate:null,
          startDate:'',
          endDate:''
        }
        this.$store.commit('SET_PAGESEARCH', {page:this.pagename,search:{}})
        this.search()
      },
      typeChange(){
        this.getList()
      },
      search(){
        this.pageObj.current = 1
        this.getList()
      },
      // 页面改版的时候
      changePage: function (current, pageSize) {
        if (this.pageObj.changeLimitNum) {
          this.pageObj.current = 1
          this.pageObj.changeLimitNum = false
        }
        else {
          this.pageObj.current = current
        }
        this.pageObj.pageSize = pageSize
        this.searchObj.pageSize = pageSize
        this.getList(current)
      },
      // 页面分页改变的时候
      changeLimitNum: function (current, pageSize) {
        this.pageObj.current = 1
        this.pageObj.pageSize = pageSize
        this.pageObj.changeLimitNum = true
        this.searchObj.pageSize = pageSize
        this.changePage(current, pageSize)
      },
      getStatus(status){
        var tmplist = this.statusList.filter(item=>{
          return (item.id == status)
        })
        return tmplist.length>0?tmplist[0].name:''
      }
    },
  }
</script>

<style lang="less" scoped>
.contbg{
  background:#edf0f3;
  .unread{
    color:#fff;
    background:#F5222D;
    padding:0 8px;
    height:16px;
    line-height:16px;
    border-radius:40px;
    font-size:12px;
    display: inline-block;
    margin-left:4px;
    vertical-align: text-bottom;
  }
}
.mgl10{margin-left:10px;}
.mgt16{margin-top:16px;}

.ad_status{
  width: 6px;
  height:6px;
  border-radius:6px;
  display:inline-block;
  margin-right:8px;
  vertical-align: middle;
}
.status_0{
  background:rgba(0,0,0,0.25);
}
.status_1{
  background:#52C41A;
}
.status_2{
  background:#F5222D;
}
.operate{
  color: #1890FF;
  cursor: pointer;
}

.msgcontent{
  display: -webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width:500px;
  max-height:180px;
  overflow: hidden;
  img{
    max-width:500px;
    max-height:180px;
  }
}
.v_video{
  max-height:112px;
}
.u_header{
  height:32px !important;
  width:32px !important;
  border-radius:2px;
  border:1px solid #e9e9e9;
}


</style>
